<template>
  <div>
    <b-row class="content-header mb-2">
      <!-- Content Left -->
      <b-col class="content-header-left" cols="12" md="9">
        <breadcrumb />
      </b-col>

      <!-- Content Right -->
      <b-col class="content-header-right text-md-right" md="3" cols="12">
        <b-button
          @click="showFormModal(null)"
          class="px-3 text-capitalize"
          variant="primary"
        >
          <feather-icon size="16" icon="PlusIcon" class="mr-50" />
          ایجاد تور
        </b-button>
      </b-col>
    </b-row>
    <div v-if="tours">
      <div class="d-flex justify-content-between align-items-center">
        <per-page v-model="perPage" class="w-50" />
      </div>
      <b-row>
        <!--        <b-col sm="6" md="3" lg="2">
                  <per-page v-model="perPage" class="w-100" />
                </b-col>-->
        <b-col sm="12" md="7" lg="8">
          <search-services
              @searchBase="searchBase"
              :selectedFilter="selectedFilter"
              :submitLoading="searchBasesubmitLoading"
              :isSearchResult="isSearchResult"
              ref="ownersSearchComponent"
              class="w-100"
              city="none"
              v-model="searchInput"
          />
        </b-col>
      </b-row>
      <b-table-simple responsive>
        <b-thead>
          <b-tr>
            <b-th>کد</b-th>
            <b-th>ترتیب</b-th>
            <b-th>عملیات</b-th>
            <b-th>وضعیت</b-th>
            <b-th>عنوان</b-th>
            <b-th>مبدا</b-th>
            <b-th>مقصد</b-th>
            <b-th>دسته بندی</b-th>
            <b-th>لیدر</b-th>
            <b-th>تاریخ ایجاد</b-th>
            <b-th>هزینه</b-th>
            <b-th>نمایش</b-th>
            <b-th> وضعیت تقویم</b-th>

          </b-tr>
        </b-thead>
        <b-tbody>
          <b-tr v-for="(tour, index) in tours" :key="tour.id">
            <b-th>
              <a
                target="_blank"
                :href="
                  'https://roomtoor.com/tour/' +
                  tour.category.slug +
                  '-' +
                  tour.code
                "
              >
                {{ tour.code }}
              </a>
            </b-th>
            <b-th>
              <span v-if="tour.show_order_number">
                {{ tour.show_order_number}}
              </span>
              <span v-else>
                ----
              </span>
            </b-th>

            <b-td>
              <b-col class="d-flex align-items-center">
                <router-link
                    v-if="tour.checkItems[0] && tour.checkItems[0].serviceable_type==='App\\Models\\Tour'"
                    :to="{ name: 'checkItems', params: {type:'tour', id: tour.id,name:tour.name } }"
                    variant="flat-primary"
                    v-b-tooltip.hover.top="tour.checkItems[0].description"
                    class="font-weight-bolder btn"
                >
                  <AlertTriangleIcon style="color: #00b782" v-if="tour.checkItems[0].status==='complete'" />
                  <AlertTriangleIcon v-else style="color: #fcb200" />
                </router-link>
                <router-link
                    v-else
                    :to="{ name: 'checkItems', params: {type:'tour', id: tour.id,name:tour.name } }"
                    variant="flat-primary"
                    v-b-tooltip.hover.top="'مشکلی ثبت نشده'"
                    class="font-weight-bolder btn"
                >
                  <AlertTriangleIcon />

                </router-link>
                <router-link
                    :to="{ name: 'specificTypeComments', params: {type:'tour', id: tour.id } }"
                    variant="flat-secondary"
                    class="font-weight-bolder btn"
                >
                  <BIconChatRightTextFill />
                </router-link>
                <router-link
                    :to="{ name: 'toursPrices', params: { id: tour.id } }"
                    variant="flat-secondary"
                    class="font-weight-bolder btn"
                >
                  <BIconCalendar2Event />
                </router-link>
                <!--                <b-button
                                  @click="showConfirmModal(tour)"
                                  variant="flat-danger"
                                  class="font-weight-bolder"
                                >
                                  <feather-icon icon="Trash2Icon" size="20" />
                                </b-button>-->
                <b-button
                    @click="showFormModal(tour, index)"
                    variant="flat-secondary"
                    class="font-weight-bolder"
                >
                  <feather-icon icon="Edit2Icon" size="20" />
                </b-button>
              </b-col>
            </b-td>
            <b-td>
              <b-col
                  class="d-flex align-items-center pl-0"
                  :class="
                  tour.status != 'active' ? 'text-danger' : 'text-success'
                "
              >
                {{ tour.status == "active" ? "" : "غیر" }}فعال
              </b-col>
            </b-td>






            <b-th>
              <a
                target="_blank"
                :href="
                  'https://roomtoor.com/tour/' +
                  tour.category.slug +
                  '-' +
                  tour.code
                "
              >
                {{ tour.name }}
              </a>
            </b-th>
            <b-th>
              {{ tour.city.name }}
            </b-th>
            <b-td>
              <span v-if="tour.destination.city_destination.name">
                {{ tour.destination.city_destination.name }}
              </span>
              <span v-if="tour.destination.capital_destination.name">
                {{ tour.destination.capital_destination.name }}
              </span>
            </b-td>

            <b-td>
              {{ tour.category.name }}
            </b-td>
            <b-td>
              <a :href="`https://roomtoor.com/user/host/${tour.host.token}`" target="_blank">
                <span class="pl-1">        {{ tour.host.full_name }}</span>
              </a>
              <br/>
              <a href="">
                <b-badge variant="primary" v-if="tour.host.mobile">
                  {{   tour.host.mobile.replace("+98","0") }}
                </b-badge>
              </a>
            </b-td>
            <b-td>
              {{
                new Date(tour.created_at).toLocaleString("fa-IR", {
                  timeZone: "Iran",
                })
              }}
            </b-td>
            <b-th>
              <span v-if="tour.tour_dates[0]" class="text-success">
                   {{tour.tour_dates[0].prices.normal_dayes}}
              </span>
              <span v-else class="text-danger">
                قیمت  ندارد
              </span>
            </b-th>
            <b-td>
              <b-col
                  class="d-flex align-items-center pl-0">
                  <span class="font-weight-bold" v-if="tour.show_index_page === true" style="color: #00c700">
                    فعال
                  </span>
                <span v-else>
                  غیرفعال
                </span>
              </b-col>
            </b-td>
            <b-td>
              <b-col
                  class="d-flex align-items-center pl-0">
                  <span class="font-weight-bold" v-if="tour.close_booking === 'active'" style="color: #00c700">
                    باز
                  </span>
                <span v-else>
                  بسته
                </span>
              </b-col>
            </b-td>

          </b-tr>
        </b-tbody>
      </b-table-simple>

      <pagination
        ref="toursPaginationComponent"
        v-model="page"
        :paginationData="paginationData"
      />
    </div>
    <b-sidebar
      width="98%"
      v-model="formModal"
      right
      backdrop
      shadow
      bg-variant="white"
    >
      <template #header>
        <div class="w-100">
          <div class="text-right">
            <b-button
              style="background-color: rgba(75, 75, 75, 0.12)"
              @click="formModal = false"
              variant="flat-dark"
              class="btn-icon rounded-circle mr-1"
            >
              <feather-icon icon="XIcon" size="20" />
            </b-button>
          </div>
          <div class="mr-1 sidebarHeaderTitleDiv">
            <h3 class="text-capitalize">
              {{ editMode ? "ویرایش تور" : "ایجاد تور" }}
            </h3>
          </div>
        </div>
      </template>
      <TourWizard
        @deleteImage="deleteImage"
        ref="tourInput"
        @getTours="getTours"
        :provinces="provinces"
        :countries="countries"
      ></TourWizard>
    </b-sidebar>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BCard,
  BAvatar,
  BButton,
  BSpinner,
  BSidebar,
  BContainer,
  BFormTextarea,
  BTableSimple,
  BThead,
  BTbody,
  BTr,
  BTh,
  BTd,
  BIconCalendar,
  BIconCalendar2Event,
  BIconChatRightTextFill, VBTooltip, BBadge
} from "bootstrap-vue";
import debounce from 'lodash/debounce';
import PerPage from "@/components/PerPage.vue";
import Breadcrumb from "@/components/Breadcrumb.vue";
import Pagination from "@/components/Pagination.vue";
import Search from "@/components/Search.vue";
import TableHead from "@/components/TableHead.vue";
import vSelect from "vue-select";
import { mapMutations, mapState, mapActions } from "vuex";
import { forEach } from "postcss-rtl/lib/affected-props";
import TourWizard from "@/components/TourWizard.vue";
import SearchServices from "@/components/SearchServices.vue";
import AlertTriangleIcon from "vue-feather-icons/icons/AlertTriangleIcon";
import Ripple from "vue-ripple-directive";

export default {
  components: {
    BBadge,
    AlertTriangleIcon,
    SearchServices,
    TourWizard,
    BRow,
    BCol,
    PerPage,
    BFormGroup,
    BFormInput,
    BCard,
    BAvatar,
    BButton,
    Breadcrumb,
    Pagination,
    Search,
    TableHead,
    BSpinner,
    BSidebar,
    BContainer,
    BFormTextarea,
    vSelect,
    BTableSimple,
    BThead,
    BTbody,
    BTr,
    BTh,
    BTd,
    BIconCalendar,
    BIconCalendar2Event,
    BIconChatRightTextFill,
    VBTooltip
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  data() {
    return {
      isSearchResult:false,
      searchBasesubmitLoading:false,
      selectedFilter:[],
      Dates: [],
      tourIndex: 0,
      itemArray: [
        {
          Item: "ACC",
          Price: 10,
          hasPrice: true,
        },
        {
          Item: "BCC",
          Price: "",
          hasPrice: false,
        },
        {
          Item: "CCC",
          Price: "",
          hasPrice: false,
        },
        {
          Item: "DCC",
          Price: "",
          hasPrice: false,
        },
        {
          Item: "ECC",
          Price: "",
          hasPrice: false,
        },
      ],
      provinces: [],
      countries: [],

      perPage: 30,
      page: 1,
      buildings: [],
      tours: null,

      defaultAvatar: require("@/assets/images/avatars/default.png"),
      cancelToken: undefined,
      sortBy: "",
      sortDir: "",
      searchInput: "",
      paginationData: null,
      tableHeadings: [
        {
          title: "شهر",
          slug: "city",
          sortable: false,
        },
        {
          title: "ساختمان",
          slug: "building",
          sortable: true,
        },
        {
          title: "نام",
          slug: "name",
          sortable: true,
        },
        {
          title: "میزبان",
          slug: "owner",
          sortable: false,
        },
        {
          title: "تعداد",
          slug: "count",
          sortable: true,
        },
        {
          title: "تاریخ ایجاد",
          slug: "created_at",
          sortable: true,
        },
        {
          title: "actions",
          sortable: false,
        },
      ],

      OpenIndicator: {
        render: (createElement) =>
          createElement("feather-icon", { attrs: { icon: "ChevronDownIcon" } }),
      },
      companies: [],
      buildingsCancelToken: undefined,
      tourInput: {
        id: "",
        building_id: "",
        name: "",
        description: "",
        body: "",
        count: "",
        bedrooms: "",
      },
      editMode: false,
      formModal: false,
      submitLoading: false,
    };
  },
  mounted() {
    this.$store.commit("verticalMenu/UPDATE_VERTICAL_MENU_COLLAPSED", false);
    this.getTours();
    this.getToursPrerequisite("regulations", "regulations");
    this.getToursPrerequisite("rules", "rules");
    this.getToursPrerequisite("categories", "categories");
    this.getToursPrerequisite("ages", "ages");
    this.getProvinces();
    this.getCountries();
    this.getUrlParams();
  },
  created() {
    this.debouncedGetReservations = debounce(this.getTours, 500);
  },
  watch: {
 /*   searchInput(value) {
      this.page = 1;
      this.getTours();
    },*/
    searchInput(value) {
      this.page = 1; // Reset the page to the beginning
      if (value.trim().length) { // Ensure there is actual input to search for
        this.debouncedGetReservations();
      }
    },
  /*  searchInput() {
      if (this.searchInput) {
        this.getTours();
      }
    },
    selectedFilter: {
      deep: true,
      handler() {
        if (this.selectedFilter.length && this.searchInput) {
          this.getTours();
        }
      }
    },*/
    perPage(value) {
      this.page = 1;
      this.getTours();
    },
    page(value) {
      this.getTours();
    },
  },
  computed: {
    ...mapState([
      "regulations_tour_state",
      "rules_tour_state",
      "categories_tour_state",
      "ages_tour_state",
    ]),
  },

  methods: {
    getUrlParams() {
      if ("filter[name]" in this.$route.query) {
        this.searchInput = this.$route.query[`filter[name]`];
        this.selectedFilter.push("name");
      }
      if ("filter[code]" in this.$route.query) {
        this.searchInput = this.$route.query[`filter[code]`];
        this.selectedFilter.push("code");
      }
      if ("filter[host]" in this.$route.query) {
        this.searchInput = this.$route.query[`filter[host]`];
        this.selectedFilter.push("host");
      }
      if ("per_page" in this.$route.query) {
        this.perPage = Number(this.$route.query[`per_page`]);
        this.$refs.userPerPageComponent.perPage = this.perPage;
      }
      if ("page" in this.$route.query) {
        this.page = this.$route.query[`page`];
      }

    },
    searchBase(data) {
      console.log("data", data);
      this.selectedFilter = data.selectedFilter;
      this.searchInput = data.searchInput;
      this.isSearchResult = this.searchInput !== "" && data.type !== "delete";
      this.searchBasesubmitLoading = true;
      this.getTours();
    },


    /*    searchBase(data) {
          console.log("data", data);

          // Only update searchInput and selectedFilter if needed
          if (data.selectedFilter.length > 0) {
            const filterCriteria = ['name', 'code', 'host', 'city'];
            const isFilterSelected = data.selectedFilter.some(filter => filterCriteria.includes(filter));
            if (isFilterSelected) {
              this.searchInput = data.searchInput;
            }
            this.selectedFilter = data.selectedFilter;
          }

          this.searchBasesubmitLoading = true;

          // Determine if a search result should be shown
          this.isSearchResult = !!this.searchInput;

          if (data.type === "delete") {
            this.isSearchResult = false;
          }

          // Trigger the search
          this.getTours();
        },*/

    /* searchBase(data) {
       console.log("data", data);
       this.selectedFilter = [];
       if (data.selectedFilter.length > 0) {
         data.selectedFilter.forEach((item) => {
           if (item == "name") {
             this.searchInput = data.searchInput;
           } else if (item == "code") {
             this.searchInput = data.searchInput;
           } else if (item == "host") {
             this.searchInput = data.searchInput;
           }
         });
         this.selectedFilter = data.selectedFilter;
       }
       this.searchBasesubmitLoading = true;
       if (this.searchInput) {
         this.isSearchResult = true;
       }
       if (data.type == "delete") {
         this.isSearchResult = false;
       }
       this.getTours();
     },*/

    deleteImage(image) {
      let tourIndex = 0;
      console.log("this.tours.images", this.tours);
      this.tours[this.tourIndex].images = Object.values(
        this.tours[this.tourIndex].images
      ).filter((tourItem, index) => {
        if (tourItem.id == image.id) {
          tourIndex = index;
        }
        return tourItem.id !== image.id;
      });
    },
    disableUnderCheckbox(data) {
      this.packages[data.index]["disable"] = data.show;
      console.log(this.packages);

      this.$set(this.packages[data.index], "disable", data.show);
      //  this.packages[data.index] = Object.assign({}, this.packages[data.index], this.packages[data.index])
    },
    getProvinces(search, loading) {
      if (typeof this.provincesCancelToken != typeof undefined) {
        this.provincesCancelToken.cancel(
          "Operation canceled due to new request."
        );
      }
      //Save the cancel token for the current request
      this.provincesCancelToken = this.$http.CancelToken.source();

      let data = {
        paginate: false,
        //  this.searchInput,
        // per_page: this.perPage,
        // page: this.page,
        // sort_by: this.sortBy,
        // sort_dir: this.sortDir,
      };

      const requestData = {
        method: "get",
        url: "/admin/states",
        params: data,
        // cancelToken: this.cancelToken.token,
      };
      this.$http(requestData)
        .then((response) => {
          let data = response.data;
          this.provinces = data.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    getCountries(search, loading) {
      if (typeof this.countriesCancelToken != typeof undefined) {
        this.countriesCancelToken.cancel(
          "Operation canceled due to new request."
        );
      }
      //Save the cancel token for the current request
      this.countriesCancelToken = this.$http.CancelToken.source();

      let data = {
        paginate: false,

        //  this.searchInput,
        // per_page: this.perPage,
        // page: this.page,
        // sort_by: this.sortBy,
        // sort_dir: this.sortDir,
      };

      const requestData = {
        method: "get",
        url: "/admin/countries",
        params: data,
        // cancelToken: this.cancelToken.token,
      };
      this.$http(requestData)
        .then((response) => {
          let data = response.data;
          this.countries = data.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    getToursPrerequisite(stateName, url) {
      // if (typeof this.cancelToken != typeof undefined) {
      //   this.cancelToken.cancel("Operation canceled due to new request.");
      // }
      //Save the cancel token for the current request
      // this.cancelToken = this.$http.CancelToken.source();

      let data = {
        // search: this.searchInput,
        // per_page: this.perPage,
        // page: this.page,
        // sort_by: this.sortBy,
        // sort_dir: this.sortDir,
      };

      const requestData = {
        method: "get",
        url: `/admin/tours/${url}`,
        // params: data,
        // cancelToken: this.cancelToken.token,
      };
      this.$http(requestData)
        .then((response) => {
          let data = response.data;
          this[stateName] = data.data;
          this[stateName].forEach((element) => {
            element["disable"] = false;
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    sort(args) {
      this.page = 1;
      this.sortBy = args.sortBy;
      this.sortDir = args.sortDir;
      this.getTours();
    },

    async getTours() {
      if (typeof this.cancelToken != typeof undefined) {
        this.cancelToken.cancel("Operation canceled due to new request.");
      }
      //Save the cancel token for the current request
      this.cancelToken = this.$http.CancelToken.source();

      let data = {
        // search: this.searchInput,
        "filter[name]": this.selectedFilter.includes("name")
            ? this.searchInput
            : "",
        "filter[code]": this.selectedFilter.includes("code")
            ? this.searchInput
            : "",
        "filter[host]": this.selectedFilter.includes("host")
            ? this.searchInput
            : "",
        per_page: this.perPage,
        page: this.page,
        // sort_by: this.sortBy,
        // sort_dir: this.sortDir,
      };

      const requestData = {
        method: "get",
        url: "/admin/tours",
        params: data,
        // cancelToken: this.cancelToken.token,
      };
      this.$http(requestData)
        .then((response) => {
          let data = response.data;
          this.tours = data.data;
          this.paginationData = data.meta;
          this.searchBasesubmitLoading = false;
        })
        .catch((err) => {
          console.log(err);
          this.searchBasesubmitLoading = false;
        });
      this.tours = [];
      this.formModal = false;
    },
    showConfirmModal(tour) {
      this.$bvModal
        .msgBoxConfirm(`آیا از حذف تور مطمئن هستید ؟  : ${tour.name}.`, {
          title: this.$t("Please Confirm"),
          size: "sm",
          okVariant: "primary",
          okTitle: this.$t("Yes"),
          cancelTitle: this.$t("No"),
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        })
        .then(async (confirmed) => {
          if (confirmed) {
            let tourIndex = 0;
            this.tours = await this.tours.filter((tourItem, index) => {
              if (tourItem.id == tour.id) {
                tourIndex = index;
              }
              return tourItem.id !== tour.id;
            });

            const requestData = {
              method: "delete",
              url: `admin/tours/${tour.id}`,
            };
            this.$http(requestData)
              .then((response) => {
                this.$bvToast.toast(`تور: ${tour.name}  با موفقیت حذف شد.`, {
                  title: this.$t("Done"),
                  variant: "success",
                  solid: true,
                });
              })
              .catch((err) => {
                let message = this.$t("Unable to delete!");
                if (
                  err.response &&
                  err.response.data &&
                  err.response.data.message
                )
                  message = err.response.data.message;
                this.$bvToast.toast(message, {
                  title: this.$t("Error"),
                  variant: "danger",
                  solid: true,
                });
                this.tours.splice(tourIndex, 0, tour);
              });
          }
        });
    },
    /*    formatePrices(prices, type) {
      if (prices.name && prices.name == "test") {
        return prices;
      }
      if (type == "prices") {
        var formatedPrices = prices;
        if (prices.normal_dayes)
          formatedPrices.normal_dayes = this.formatnumber(prices.normal_dayes);
        if (prices.weekend_days)
          formatedPrices.weekend_days = this.formatnumber(prices.weekend_days);
        if (prices.peack_days)
          formatedPrices.peack_days = this.formatnumber(prices.peack_days);
        if (prices.extra_guest)
          formatedPrices.extra_guest = this.formatnumber(prices.extra_guest);
        if (prices.pricePerBaby.price !== null) {
          formatedPrices.pricePerBaby.price = this.formatnumber(
              prices.pricePerBaby.price
          );
        }
        if (prices.pricePerAnimal.price !== null) {
          formatedPrices.pricePerAnimal.price = this.formatnumber(
              prices.pricePerAnimal.price
          );
        }
        return formatedPrices;
      } else {
        var formatedSpecial_services = prices;
        if (prices && prices[0] !== null) {
          Object.keys(prices).forEach((element) => {
            formatedSpecial_services[element].price = this.formatnumber(
                prices[element].price
            );
          });

          return formatedSpecial_services;
        }
      }
    },*/
    formatnumber(newValue) {
      console.log("newValue", newValue);
      const result = newValue
        .toString()
        .replace(/\D/g, "")
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return result;
    },
    //     monthsBetweenDates(startDate, endDate) {
    //       const now = startDate,
    //         dates = [];

    //       while (now.isSameOrBefore(endDate)) {
    //         // console.log(now.format("dddd"))
    //         if (
    //           now.format("dddd") === "پنج‌شنبه" ||
    //           now.format("dddd") === "چهارشنبه"
    //         ) {

    //           dates.push({ isWeakend: true, date: now.locale('en').format("YYYY/MM/DD"),

    //           books_count:0,
    // disable_count:0,
    // is_custom_price:false,
    // price:

    //           });
    //         } else {
    //           dates.push({ date: now.locale('en').format("YYYY/MM/DD") });
    //         }

    //         now.add(1, "days");
    //       }
    //       return dates;
    //     },
    getDatesFromStartTo6Month() {
      // console.log(this.$moment)
      const endofMonth1 = this.$moment(this.date);
      const toDate1 = this.$moment(endofMonth).endOf("month");
      console.log(endofMonth1, toDate1);
      // console.log("monthsBetweenDates",this.monthsBetweenDates(endofMonth1,toDate1))
      // console.log("date",this.$options.filters.moment(this.date,"jD jMMMM,jYYYY HH:mm").getDay())
      // console.log(this.$moment(this.date).endOf('month').format('YYYY/MM/D'))
      const endofMonth = this.$moment(this.date).endOf("month");
      const toDate = this.$moment(endofMonth).add(6, "months").endOf("month");

      // console.log("toDate",toDate.format('YYYY/MM/D'))
      // console.log("monthsBetweenDates",this.monthsBetweenDates(endofMonth,toDate))
      var x = this.monthsBetweenDates(endofMonth1, toDate1);

      x.splice(-1);
      var y = this.monthsBetweenDates(endofMonth, toDate);
      // this.date.moment("jD jMMMM,jYYYY HH:mm").getDay()
      this.Dates = [...x, ...y];

      console.log(this.Dates);
      return this.Dates;
    },
    showFormModal(tour, index) {
      console.log("tour", tour);
      if (tour) {
        this.$refs.tourInput.$refs.formWizard.activateAll();
        this.$refs.tourInput.tourInput = {
          id: tour.id,
          name: tour.name,
          slug: tour.slug,
          host_id: tour.host.id,
          category_id: tour.category.id,
          age_id: tour.age.id,
          tour_style: tour.tour_style,
          tour_difficulty: tour.tour_difficulty,
          tour_transportation: tour.tour_transportation,
          min_day_before_reservation: tour.min_day_before_reservation,
          min_people: tour.min_people,
          max_people: tour.max_people,
          price: tour.price,
          description: tour.description,
          visa_description: tour.visa_description,
          covid: tour.covid,
          blog_url: tour.blog_url,
          spaces: tour.spaces,
          rules: tour.rules,
          close_booking: tour.close_booking,
          transfer_description: tour.transfer_description,
          // regulations: tour.regulations,
          tour_origin_position: tour.tour_origin_position,
          state_id: tour.state.id,
          city_id: tour.city.id,
          country_id: tour.country.id,
          capital_id: tour.capital.id,
          address_origin: tour.address_origin,
          lat_origin: tour.lat_origin,
          lng_origin: tour.lng_origin,

          tour_destination_position: tour.destination.tour_destination_position,
          state_destination_id: tour.destination.state_destination.id,
          city_destination_id: tour.destination.city_destination.id,
          country_destination_id: tour.destination.country_destination.id,
          capital_destination_id: tour.destination.capital_destination.id,
          address_destination: tour.destination.address_destination,
          lat_destination: tour.destination.lat_destination,
          lng_destination: tour.destination.lng_destination,

          days: tour.days,
          include: tour.include,
          exclude: tour.exclude,
          faqs: tour.faqs,

          seo_data_title: tour.seo_data.title,
          seo_data_keywords: tour.seo_data.keywords,
          seo_data_description: tour.seo_data.description,
          seo_data_schema: tour.seo_data.schema,

          commission_per_person: tour.commission_per_person,
          commission_per_group: tour.commission_per_group,
          show_order_number: tour.show_order_number,
          videos: tour.videos,
          podcasts: tour.podcasts,
          status: tour.status,
          images: tour.images,
          show_index_page: tour.show_index_page,
          show_date_page: tour.show_date_page,
          score: tour.score,
        };

        // (this.$refs.tourInput.regulationsItemArray =
        //   tour.regulations),
        this.$refs.tourInput.categories = this.categories;
        this.$refs.tourInput.ages = this.ages;

        var regulationsData = [];

        this.regulations.forEach((initialRegulation, index) => {
          regulationsData.push(initialRegulation);
          tour.regulations.forEach((saveRegulation) => {
            if (initialRegulation.id == saveRegulation.tour_regulation.id) {
              regulationsData[index] = saveRegulation;
            }
          });
        });

        this.$refs.tourInput.helperRegulation = [...tour.regulations];
        this.$refs.tourInput.helperRules = [...tour.rules];

        (this.$refs.tourInput.regulationsItemArray = regulationsData),
          (this.$refs.tourInput.rules = this.rules);

        if (tour.destination.tour_destination_position == "داخلی") {
          this.$refs.tourInput.getCityByProvinceId(
            tour.destination.state_destination.id,
            "destinationMode"
          );
        } else if (tour.destination.tour_destination_position == "خارجی") {
           this.$refs.tourInput.getCapitalByCountryId(
          tour.destination.country_destination.id,
          "destinationMode"
        );

        }
       
        if (tour.tour_origin_position == "داخلی") {
          this.$refs.tourInput.getCityByProvinceId(tour.state.id, "originMode");
        } else if (tour.tour_origin_position == "خارجی") {
          this.$refs.tourInput.getCapitalByCountryId(
            tour.country.id,
            "originMode"
          );
        }

        this.$refs.tourInput.searchLatLng();
        this.$refs.tourInput.tourIndex = index;

        this.tourIndex = index;
        this.editMode = true;
        this.$refs.tourInput.dates = null;
        this.$refs.tourInput.editMode = this.editMode;
      } else {
        this.$refs.tourInput.$refs.formWizard.reset();
        this.$refs.tourInput.showDestinationMap = true;
        this.$refs.tourInput.showOriginMap = true;
        this.$refs.tourInput.tourInput = {
          name: "",
          slug: "",
          host_id: "",
          category_id: "",
          age_id: "",
          tour_style: "",
          tour_difficulty: "",
          tour_transportation: "",
          min_day_before_reservation: "",
          min_people: "",
          max_people: "",
          price: "",
          description: "",
          visa_description: "",
          covid: "",
          blog_url: "",

          days: [
            {
              dayTitle: "روز جدید",
              spaces: [
                {
                  title: "",
                  description: "",
                  image: { url: "", id: "" },
                  blog_url: "ee",
                  duration: "",
                  imageUploaderLoading: false,
                },
              ],
            },
          ],
          include: [],
          exclude: [],
          faqs: { 0: "null" },
          spaces: [],
          rules: [],

          status: "",
          commission_per_person: "",
          commission_per_group: "",
          show_order_number: "",
          seo_data_title: "",
          seo_data_keywords: "",
          seo_data_description: "",
          seo_data_schema: "",
          videos: "",
          podcasts: "",
          status: "active",

          tour_origin_position: "داخلی",
          state_id: "",
          city_id: "",
          country_id: "",
          capital_id: "",
          tour_position: "",
          lat_origin: "",
          lng_origin: "",
          address_origin: "",
          score: "",
          show_date_page: true,

          tour_destination_position: "داخلی",
          state_destination_id: "",
          city_destination_id: "",
          capital_destination_id: "",
          country_destination_id: "",
          lat_destination: "",
          lng_destination: "",
          address_destination: "",

          faqs: [],
          include: [],
          exclude: [],
          show_index_page: true,
          min_day_before_reservation: "",
        };

        this.$refs.tourInput.categories = this.categories;
        this.$refs.tourInput.ages = this.ages;

        (this.$refs.tourInput.regulationsItemArray = this.regulations),
          (this.$refs.tourInput.rules = this.rules);
        this.$refs.tourInput.specialServices = 0;
        // console.log(
        //   "this.autoimmune_packages_state",
        //   this.$store.state.app.autoimmune_packages_state
        // );
        // console.log(
        //   "this.regulations_state",
        //   this.$store.state.app.regulations_state
        // );
        // console.log(
        //   "this.packages_state",
        //   this.$store.state.app.packages_state
        // );
        // console.log(
        //   "this.health_items_state",
        //   this.$store.state.app.health_items_state
        // );
        // console.log("this.rules_state", this.$store.state.app.rules_state);
        this.$refs.tourInput.tourIndex = 0;

        this.editMode = false;
        this.$refs.tourInput.editMode = this.editMode;
      }
      // this.$refs.tourInput.dates=this.getDatesFromStartTo6Month()
      this.formModal = true;
    },
    submitForm() {
      if (this.submitLoading) return;
      let errorMessage = null;
      if (!errorMessage && !this.tourInput.building_id) {
        errorMessage = "لطفا یک کاربر را انتخاب کنید";
      }
      if (!errorMessage && !this.tourInput.name) {
        errorMessage = "لطفا رمز را وارد کنید";
      }

      if (!errorMessage && !this.tourInput.description) {
        errorMessage = "لطفا توضیحات را وارد کنید";
      }

      if (!errorMessage && !this.tourInput.body) {
        errorMessage = "لطفا متن را وارد کنید";
      }

      if (!errorMessage && !this.tourInput.count) {
        errorMessage = "لطفا تعداد را وارد کنید";
      }

      if (!errorMessage && !this.tourInput.bedrooms) {
        errorMessage = "لطفا تعداد اتاق خواب را وارد کنید";
      }

      if (errorMessage) {
        this.$bvToast.toast(errorMessage, {
          title: this.$t("Error"),
          variant: "danger",
          solid: true,
        });
        return;
      }

      this.submitLoading = true;

      const requestData = {
        method: this.editMode ? "patch" : "post",
        url: this.editMode ? `tours/${this.tourInput.id}` : `tours`,
        data: this.tourInput,
      };

      this.$http(requestData)
        .then((response) => {
          let message = "تور با موفقیت اضافه شد";
          if (this.editMode) message = "تور با موفقیت ویرایش شد";
          this.$bvToast.toast(message, {
            title: this.$t("Done"),
            variant: "success",
            solid: true,
          });
          if (!this.editMode && this.buildings && this.buildings.length > 0) {
            this.$refs.toursPaginationComponent.clear();
            this.$refs.toursSearchComponent.clear();
            this.$refs.toursTableHeadComponent.clear();
            this.page = 1;
            this.searchInput = "";
            this.sortBy = "";
            this.sortDir = "";
          }

          this.submitLoading = false;
          this.formModal = false;
          this.getTours();
        })
        .catch((err) => {
          let message = "خطا در ایجاد تور";
          if (this.editMode) message = "خطا در ویرایش تور";
          if (err.response && err.response.data && err.response.data.message)
            message = err.response.data.message;

          this.$bvToast.toast(message, {
            title: this.$t("Error"),
            variant: "danger",
          });
          this.submitLoading = false;
          console.log(err);
        });
    },
    getBuildings(search, loading) {
      if (typeof this.buildingsCancelToken != typeof undefined) {
        this.buildingsCancelToken.cancel(
          "Operation canceled due to new request."
        );
      }
      //Save the cancel token for the current request
      this.buildingsCancelToken = this.$http.CancelToken.source();

      let data = {
        search: search,
        per_page: 10,
        page: 1,
      };

      const requestData = {
        method: "get",
        url: "buildings",
        params: data,
        cancelToken: this.buildingsCancelToken.token,
      };
      this.$http(requestData)
        .then((response) => {
          let data = response.data.data;
          this.buildings = data.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
